import { createEnvelopeSource } from './create-envelope-source';
import { NHL_COINS_EDITION_ID } from './nhl-coins-edition';

export const campaignNhlCoinsPopularitySource = createEnvelopeSource({
    label: 'NHL Coins coin popularity',
    endpoint: 'analytics/campaign-nhl-coins-popularity-member',
    metrics: [{ id: 'coinsHeld', label: 'Coins held', type: 'scalar' }],
    forms: ['bars'],
    regionGrain: 'province',
    staticParams: { campaignId: NHL_COINS_EDITION_ID },
});
